const state = {
    errors: {},
    formOpen: false,
    noteInForm: {},
    notes: [],
    participant: {},
    users: []
}

const getters = {
    //
}

const mutations = {
    setErrors (state, data) {
        return state.errors = data
    },
    setNotes (state, data) {
        return state.notes = data
    },
    setFormOpen (state, data) {
        return state.formOpen = data
    },
    setNoteInForm (state, data) {
        return state.noteInForm = data
    },
    setParticipant (state, data) {
        return state.participant = data
    },
    setUsers (state, data) {
        return state.users = data
    },
}

const actions = {
    closeForm(context) {
        context.commit("setFormOpen", false)
        context.commit("setErrors", {})
        context.commit("setNoteInForm", {})
    },
    deleteNote(context, note) {
        if(confirm('You are about to delete a note. This cannot be undone. Are you sure you want to continue?')) {
            axios.delete('/api/notes/' + note.id)
                .then(response => {
                    context.dispatch('fetchNotes', {'participant_id': state.participant.id});
                });
        }
    },
    fetchNotes (context, data) {
        axios.get('/api/notes', {params: data})
        .then( (response) => {
            context.commit("setNotes", response.data.data)
        })
        .catch( (e) => {
            console.log("Error: notes.js, fetchNotes(), "+ e.message)          
        })
    },
    fetchUsers (context, data) {
        axios.get('/api/users')
        .then( (response) => {
            context.commit("setUsers", response.data) // make UserResource
        })
        .catch( (e) => {
            console.log("Error: notes.js, fetchUsers(), "+ e.message)          
        })
    },
    saveNote (context, noteData) {
        context.commit("setErrors", {})

        const {id, ...data} = noteData;

        let url = '/api/notes';
        let fd = new FormData();
        Object.keys(data).forEach(key => fd.append(key, data[key]));

        if (id) {
            url = [url, id].join('/');
            fd.append('_method', 'PATCH');
        }

        axios.post(url, fd)
            .then((response) => {
                context.dispatch('fetchNotes', {'participant_id': state.participant.id});
                context.dispatch('closeForm');
            }).catch((e) => {
                context.commit("setErrors", e.response.data.errors)
            })
    },
    setFormOpen (context, data) {
        context.commit("setFormOpen", data)
    },
    setNoteInForm (context, data) {
        context.commit("setNoteInForm", data)
    },
    setParticipant (context, data) {
        context.commit("setParticipant", data)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}